import autoBind from 'react-autobind';
import {connect} from 'react-redux';
import {loadSchoolDetail} from '../actions';
import Receipt from 'material-ui/svg-icons/action/receipt';
import {white} from 'material-ui/styles/colors';
import {withRouter} from 'react-router';
import React, {Component, PropTypes} from 'react';

class SideNavigationTitle extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }

  componentDidMount() {
    const {dispatch} = this.props;

    dispatch(loadSchoolDetail());
  }

  render() {
    const iconStyle = {
      height: 15,
      width: 15,
      marginBottom: -3,
      marginRight: 5,
    };

    if (!this.props.schoolName) return <div />;

    return (
      <div>
        <div className="school-name">{this.props.schoolName}</div>
        <div className="ticket-count">
          <Receipt color={white} style={iconStyle} />{this.props.ticketCount.toLocaleString()} Tickets
        </div>
      </div>
    );
  }
}

SideNavigationTitle.propTypes = {
  dispatch: PropTypes.func.isRequired,
  schoolName: PropTypes.string.isRequired,
  ticketCount: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
  const {sideNavigationTitle} = state.features.sideNavigationTitle;
  return {
    schoolName: sideNavigationTitle.get('schoolName'),
    ticketCount: sideNavigationTitle.get('ticketCount')
  };
}

export default withRouter(connect(mapStateToProps)(SideNavigationTitle));



// WEBPACK FOOTER //
// ./app/features/sideNavigationTitle/components/SideNavigationTitle.js